/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { Container } from './container';
import { useNavigate } from 'react-router-dom';
import { routes } from '@/AppNavigator/services/config/routes.config';

export const BuyInsurancePage = ({ navigation }: { navigation: any }) => {
  const navigate = useNavigate();
  return (
    <Container
      onCloseClick={() => navigate(-1)}
      onViewPolicyClick={() =>
        navigate(routes?.MyAccount?.path || '/my-profile')
      }
      onVerifySuccess={() => navigate(routes?.MyAccount?.path || '/my-profile')}
    />
  );
};
